i18n.LANGUAGES = [{
	id: 'cs',
	lang: 'cs-CZ',
	name: 'Česky',
}/*, {
	id: 'en',
	lang: 'en-US',
	name: 'English',
}, {
	id: 'de',
	lang: 'de',
	name: 'Deutsche',
}*/];

function prepFormat(valPrep, fmt, postProc = v => v) {
	return v => {
		if (v != null) {
			v = valPrep(v);

			return postProc(fmt.format(v));
		}

		return '';
	};
}

/*
 * Keep in sync with be/sheet-worker.js
 */
Formats = ((lang) => ({
	
	time: prepFormat(v => new Date(v), new Intl.DateTimeFormat(lang, { hour: 'numeric', minute: 'numeric', second: 'numeric' })),
	
	date: prepFormat(v => new Date(v), new Intl.DateTimeFormat(lang, { year: 'numeric', month: 'numeric', day: 'numeric' })),
	date_utc: prepFormat(v => new Date(v), new Intl.DateTimeFormat(lang, { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' })),
	datetime: prepFormat(v => new Date(v), new Intl.DateTimeFormat(lang, { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'})),
	datetime_seconds: prepFormat(v => new Date(v), new Intl.DateTimeFormat(lang, { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'})),

	date_weekday: prepFormat(v => new Date(v), new Intl.DateTimeFormat(lang, { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric' })),

	time_short: prepFormat(v => new Date(v), new Intl.DateTimeFormat(lang, { hour: '2-digit', minute: '2-digit' })),
	time_short_utc: prepFormat(v => new Date(v), new Intl.DateTimeFormat(lang, { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' })),
	date_day_of_week: prepFormat(v => new Date(v), new Intl.DateTimeFormat(lang, { weekday: 'long' })),
	
	date_or_datetime: v => {
		if (v == null) {
			return '';
		}

		let vd = new Date(v * 1000);
		if (vd.getHours() == 0 && vd.getMinutes() == 0 && vd.getSeconds() == 0) {
			return Formats.date(v);
		} else {
			return Formats.datetime(v);
		}
	},

	input_date: v => {
		let d = new Date(v * 1000);

		if (lang == 'cs-CZ') {
			return d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear();
		} else {
			return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();
		}
	},

	input_datetime: v => {
		let d = new Date(v * 1000);
		let has_time = (d.getHours() + d.getMinutes() + d.getSeconds() + d.getMilliseconds()) > 0;

		function p(number) {
			return number < 10 ? '0' + number : number;
		}

		return Formats.input_date(v) + (has_time ? ' ' + d.getHours() + ':' + p(d.getMinutes()) : '');
	},

	percent: v => {
		if (v == null) {
			return '';
		}
		v = Math.round(v * 100);
		return v + '\u2009%';
	},
	
	size: v => {
		if (v == null) {
			return '';
		}
		let size = v;
		const units = ['B', 'kB', 'MB', 'GB' , 'TB'];
		let i = 0;
		while (units[i] && size > 1024) {
			size /= 1024;
			i++;
		}
		return (Math.round(size * 10) / 10) + ' ' + units[i];
	},

	bool: v => {
		return v ? _('Ano') : _('Ne');
	},

	integer: v => {
		if (v == null || isNaN(v)) {
			return '';
		}
		return Number(v).toFixed(0);
	},
	
	currency_CZK: v => {
		if (v == null || isNaN(v)) {
			return '';
		}
		return (+v).toLocaleString(lang, {style: 'currency', currency: 'CZK'});
	},
}))({
	cs: 'cs-CZ',
	en: 'en-US',
	de: 'de',
}[i18n.lang]);

let Uploads = {
	fileSelect(accept) {
		return new Promise((res, rej) => {
			let fileEl = document.gwCreateElement({
				nodeName: 'input',
				type: 'file',
				accept,
				capture: 'environment',
				'style:display': 'none',
				'on:change': ev => {
					res(fileEl.files[0]);
					fileEl.remove();
				}
			});

			// iOS Safari requires file input to be in the DOM
			document.body.appendChild(fileEl);
			fileEl.click();
		});
	},

	uploadFile(path, file, {signal, progress, headers} = {}) {
		return new Promise((res, rej) => {
			let xhr = new XMLHttpRequest();

			if (signal instanceof AbortSignal) {
				signal.onabort = () => {
					rej(new AbortError);
					xhr.abort();
				};
			}

			xhr.open('POST', API_BASE + path, true);
			xhr.timeout = 60 * 60 * 1000; // 1 hour
			xhr.responseType = 'json';
			xhr.setRequestHeader('X-Anti-CSRF', '1');
			xhr.setRequestHeader('X-File-Name', encodeURI(file.name));
			for (let [k, v] of Object.entries(headers || {})) {
				xhr.setRequestHeader(k, v);
			}

			xhr.onabort = ev => {
				rej(new AbortError);
			};

			xhr.ontimeout = ev => {
				rej(new Error(_('Nahrání selhalo - vypršel časový limit')))
			};

			xhr.onerror = ev => {
				rej(new Error(_('Nahrání selhalo - neznámá chyba')))
			};

			xhr.upload.onprogress = ev => {
				if (ev.lengthComputable) {
					progress && progress(ev);
				}
			};

			xhr.onload = ev => {
				if (xhr.status >= 200 && xhr.status < 300) {
					res(xhr.response);
				} else {
					let err = new Error(xhr.response ? xhr.response.error : _('Neznámá chyba'));
					err.xhr = xhr;
					rej(err);
				}
			};

			xhr.send(file);
		});
	},
};

let Export = {
	async xlsx(config, {signal} = {}) {
		try {
			let res = await fetch(API_BASE + 'export/xlsx', {
				method: 'POST',
				mode: 'same-origin',
				headers: {
					'Content-Type': 'application/json;charset=utf-8',
					'X-Anti-CSRF': '1',
				},
				body: JSON.stringify(config),
				cache: 'default',
				signal,
			});

			if (res.ok) {
				let blob = new File([await res.blob()], config.filename);
				let file = URL.createObjectURL(blob);

				const a = document.createElement("a");
				a.href = file;
				a.download = config.filename;
				a.click();
				window.URL.revokeObjectURL(file);
			} else {
				let errData = {};
				try {
					errData = await res.json();
				} catch (ex) {}

				let err = new RESTError((errData || {}).error || `XLSX export failed with status: ${res.status}`);
				err.status = res.status;
				throw err;
			}
		} catch (ex) {
			if (ex instanceof DOMException) {
				throw new AbortError();
			}

			throw ex;
		}
	},
};
